import { render, staticRenderFns } from "./addBanner.vue?vue&type=template&id=91cc490a&scoped=true"
import script from "./addBanner.vue?vue&type=script&lang=js"
export * from "./addBanner.vue?vue&type=script&lang=js"
import style0 from "./addBanner.vue?vue&type=style&index=0&id=91cc490a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91cc490a",
  null
  
)

export default component.exports